module.exports = __webpack_public_path__ + "static/img/4384_phase_function_Paper_Points.e4711ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4384_phase_function_Paper_Points.png
// module id = dfrk
// module chunks = 0